import { Dispatch, ReactElement, SetStateAction } from "react"

import { DispatchStatusSelector } from "../selectors"

interface DispatchStatusQueryParams {
	statusId: string | null
}

export interface DispatchStatusQueryFilterProps<
	QueryParamState extends DispatchStatusQueryParams,
> {
	queryParamState: QueryParamState
	setQueryParamState: Dispatch<SetStateAction<QueryParamState>>
}

export const DispatchStatusQueryFilter = <QueryParamState extends DispatchStatusQueryParams>({
	queryParamState,
	setQueryParamState,
}: DispatchStatusQueryFilterProps<QueryParamState>): ReactElement => {
	const handleChange = (newValue: string | null) => {
		setQueryParamState((prev) => ({
			...prev,
			statusId: newValue,
		}))
	}

	return (
		<DispatchStatusSelector
			value={queryParamState.statusId}
			onChange={handleChange}
			disableNoSelectionOption={false}
			noSelectionOptionText="Any status"
			fillContainer
		/>
	)
}
